import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {
    NavigationService,
    ProblemInstanceService,
    SkillLevelService,
    TaskService,
    TaskView
} from 'planner-shared';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DropdownItem, ModalService} from '@shared';
import {Observable} from 'rxjs';
import {CompetenceUpdateModalComponent} from "./competence-update-modal/competence-update-modal.component";

@Component({
    selector: 'app-employee-unassigned-tasks-edit',
    templateUrl: './employee-unassigned-tasks-edit.component.html',
    styleUrls: ['./employee-unassigned-tasks-edit.component.scss'],
    standalone: false
})
export class EmployeeUnassignedTasksEditComponent implements OnInit {
    private readonly formBuilder = inject(FormBuilder);
    private readonly navigationService = inject(NavigationService);
    private readonly problemInstanceService = inject(ProblemInstanceService);
    private readonly skillLevelService = inject(SkillLevelService);
    private readonly modalService = inject(ModalService);
    private readonly taskService = inject(TaskService);


    @Input() set unassignedTaskParam(
        unassignedTask: TaskView
    ) {
        this.unassignedTask = unassignedTask;
    }

    public skillLevelDropdownItems$: Observable<DropdownItem[]>;

    @Output() public disableDraggingEmitter: EventEmitter<boolean> = new EventEmitter();
    @Output() public updateGeneralTaskListEmitter: EventEmitter<void> = new EventEmitter();
    public unassignedTask: TaskView;
    public taskForm: FormGroup;
    public rosterPresent: boolean;
    private resetSkillId: number;

    ngOnInit(): void {
        this.problemInstanceService.rosterDepartmentIsPartOfInstance().subscribe(rosterPresent => {
            this.rosterPresent = rosterPresent;
        });
        this.resetSkillId = this.unassignedTask.skillRequirement;
        this.skillLevelDropdownItems$ =
            this.skillLevelService.getAvailableSkillRequirementDropdownItems(this.unassignedTask);
        this.taskForm = this.initTaskForm();
    }

    public save(): void {
        if (!this.taskForm || this.taskForm.pristine || this.taskForm.invalid) {
            return;
        }
        this.modalService.openCustomModal(
            CompetenceUpdateModalComponent,
            () => {
                this.navigationService.disableNextButton(false);
                this.disableDraggingEmitter.emit(false);
                this.updateGeneralTaskListEmitter.emit();
                this.taskService.reloadGeneralTasks();
            },
            () => this.revert(),
            {
                unassignedTask: this.unassignedTask,
                selectedSkillId: this.taskForm.controls['skillRequirement'].value
            },
            false
        );
    }

    public revert(): void {
        if (this.taskForm.dirty) {
            this.unassignedTask.skillRequirement = this.resetSkillId;
            this.taskForm.patchValue(this.unassignedTask);
            this.taskForm.markAsPristine();
            this.navigationService.disableNextButton(false);
            this.disableDraggingEmitter.emit(false);
            this.unassignedTask.editing = false;
        } else {
            this.disableDraggingEmitter.emit(false);
            this.unassignedTask.editing = false;
        }
    }

    private initTaskForm(): FormGroup {
        return this.formBuilder.group(
            {
                skillRequirement: [
                    this.unassignedTask.skillRequirement,
                    Validators.compose([
                        Validators.required
                    ])
                ]
            }
        );
    }
}
